(function () {
    const cusMenu = document.querySelector('.cus-menu');
    if (cusMenu) {
        const isMobile = document.body.clientWidth < 768;
        const articleTop = document.querySelector('article').getBoundingClientRect().top + window.scrollY;
        document.body.appendChild(cusMenu);
        let cusMenuHeight = cusMenu.getBoundingClientRect().height;

        const iconMenu = cusMenu.querySelector('.menu');
        const iconClose = cusMenu.querySelector('.close');
        if (isMobile) {
            cusMenu.classList.remove('active')
        }
        const links = cusMenu.querySelectorAll('a');
        links.forEach((item, i) => {
            const targetId = item.getAttribute('href').replace('#', '');
            const target = document.getElementById(targetId);
            if (target) {

                

                item.addEventListener('click', function (e) {
                    e.preventDefault();
                  const rect = target.getBoundingClientRect();
                const top = rect.top + window.scrollY;
                    window.scrollTo({
                        top,
                        behavior: 'smooth' // 平滑滚动
                    });
                })
            }
        })
        iconMenu.addEventListener('click', () => {
            cusMenu.classList.add('active');
            cusMenu.style.height = cusMenuHeight + 'px';
        })
        iconClose.addEventListener('click', () => {
            cusMenu.classList.remove('active');
            cusMenu.style.height = '64px';
        })
        window.addEventListener('scroll', () => {

            if (window.scrollY > articleTop) {
                const v = cusMenu.getBoundingClientRect().height
                cusMenuHeight = Math.max(v, cusMenuHeight);
                cusMenu.style.zIndex = 100;
                cusMenu.style.opacity = 1;

            } else {
                cusMenu.style.zIndex = -1;
                cusMenu.style.opacity = 0;
                if (isMobile) {
                    cusMenu.classList.remove('active')
                    cusMenu.style.height = '64px';
                }
            }
        });

    }
})();